import {IconBinaryTree2, IconHistory, IconMapPin, IconPhoto, IconUsers} from '@tabler/icons-react'

export type Section = 'tree' | 'people' | 'places' | 'media' | 'history'

const ITEMS: {id: Section; label: string; Icon: typeof IconUsers; owner?: boolean}[] = [
  {id: 'tree', label: 'Древо', Icon: IconBinaryTree2},
  {id: 'people', label: 'Люди', Icon: IconUsers},
  {id: 'places', label: 'Места', Icon: IconMapPin},
  {id: 'media', label: 'Фото и документы', Icon: IconPhoto},
  // журнал правок — только владельцу дерева
  {id: 'history', label: 'Журнал правок', Icon: IconHistory, owner: true},
]

export default function Nav({value, onChange, owner}: {
  value: Section
  onChange: (s: Section) => void
  /** владелец дерева: ему одному показываем журнал */
  owner: boolean
}) {
  return (
    <nav className="rail">
      {ITEMS.filter(i => !i.owner || owner).map(({id, label, Icon}) => (
        <button
          key={id}
          className={value === id ? 'on' : ''}
          onClick={() => onChange(id)}
          aria-label={label}
          aria-current={value === id}
        >
          <Icon size={21} stroke={1.7} />
          <span className="tip">{label}</span>
        </button>
      ))}
    </nav>
  )
}
